import React, { useState, useEffect, useCallback } from 'react';
import {
  getStudentActivities,
  getAdminActivities,
} from '../../../../services/apiService';
import { getFullName } from '../../../../utils';
import moment from 'moment';
import RenderProfilePic from '../../../../extras/RenderProfilePic';
import { Button } from 'semantic-ui-react';
// import usePaginationState from '../utils/usePaginationState';

// placementSpocFilter is an array of placementSpocIds
// which can be used to filter admin activies by matching adminIds to the set of placementSpocIds
export const ActivityList = ({
  listType = 'Admin',
  filters,
  placementSpocFilter,
  loading,
  adminPage,
  setAdminPage,
  adminTotalCount,
  setAdminTotalCount,
  studentPage,
  setStudentPage,
  studentTotalCount,
  setStudentTotalCount,
}) => {
  const { userIds, companyIds, dateRangeStart, dateRangeEnd } = filters; // useEffect[filters] was getting triggered everytime placement spoc got changed
  const [adminActivities, setAdminActivities] = useState([]);
  const [studentActivities, setStudentActivities] = useState([]);
  // const [filteredAdminActivities, setFilteredAdminActivities] = useState([]);
  // const {
  //   page: studentPage,
  //   setPage: setStudentPage,
  //   totalCount: studentTotalCount,
  //   setTotalCount: setStudentTotalCount,
  // } = usePaginationState();

  // const {
  //   page: adminPage,
  //   setPage: setAdminPage,
  //   totalCount: adminTotalCount,
  //   setTotalCount: setAdminTotalCount,
  // } = usePaginationState();

  const renderActivityText = (activity, activityType) => {
    const activityTypes = {
      FEEDBACK_AND_QUESTIONS: 'feedback_and_questions',
      ADD_ROUND_TIMING: 'add_round_timing',
      UPDATE_ROUND_DECISION: 'update_round_decision',
      CREATE_JOB_GROUP: 'create_job_group',
    };
    const name =
      listType === 'Admin'
        ? getFullName(activity.adminDetails)
        : getFullName(activity.userDetails);
    const studentName = activity?.studentDetails
      ? `${getFullName(activity?.studentDetails)}'s`
      : '';

    switch (activityType) {
      case activityTypes.FEEDBACK_AND_QUESTIONS:
        return `${name} has updated ${studentName} feedback for round ${
          activity?.roundDetails?.roundNumber ?? 'N/A'
        } at ${activity?.companyDetails?.companyName ?? 'N/A'}`;
      case activityTypes.ADD_ROUND_TIMING:
        return `${name} has updated ${studentName} interview schedule for round ${
          activity?.roundDetails?.roundNumber ?? 'N/A'
        } at ${activity?.companyDetails?.companyName ?? 'N/A'}`;
      case activityTypes.UPDATE_ROUND_DECISION:
        return `${name} has updated ${studentName} interview decision for round ${
          activity?.roundDetails?.roundNumber ?? 'N/A'
        } at ${activity?.companyDetails?.companyName ?? 'N/A'}`;
      case activityTypes.CREATE_JOB_GROUP:
        return `${name} has created job group ${
          activity?.companyDetails?.companyName ?? 'N/A'
        }`;
      default:
        return '';
    }
  };

  // useEffect(() => {
  //   if (listType === 'Admin') {
  //     if (adminPage !== 0) setAdminPage(0);
  //   }
  //   if (listType === 'Student') {
  //     if (studentPage !== 0) setStudentPage(0);
  //   }
  // }, [
  //   userIds,
  //   companyIds,
  //   dateRangeStart,
  //   dateRangeEnd,
  //   placementSpocFilter,
  //   listType,
  // ]);

  const fetchAdminActivities = useCallback(async () => {
    try {
      // setLoading(true);
      const _adminActivities = await getAdminActivities({
        page: adminPage,
        size: 10,
        userIds,
        companyIds,
        dateRangeStart,
        dateRangeEnd,
        placementSpocIds: placementSpocFilter,
      });
      console.log('adminActivities', _adminActivities);
      // setLoading(false);
      if (adminPage !== 0) {
        setAdminActivities((currentAdminActivities) => [
          ...currentAdminActivities,
          ..._adminActivities?.data,
        ]);
      } else {
        setAdminActivities(_adminActivities?.data);
      }
      setAdminTotalCount(_adminActivities?.totalCount);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  }, [
    adminPage,
    placementSpocFilter,
    userIds,
    companyIds,
    dateRangeStart,
    dateRangeEnd,
    listType,
  ]);

  const fetchStudentActivities = useCallback(async () => {
    try {
      // setLoading(true);
      const _studentActivities = await getStudentActivities({
        page: studentPage,
        size: 10,
        userIds,
        companyIds,
        dateRangeStart,
        dateRangeEnd,
      });
      console.log('studentActivities', _studentActivities);
      // setLoading(false);
      if (studentPage !== 0) {
        setStudentActivities((currentStudentActivities) => [
          ...currentStudentActivities,
          ..._studentActivities?.data,
        ]);
      } else {
        setStudentActivities(_studentActivities?.data);
      }
      setStudentTotalCount(_studentActivities?.totalCount);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  }, [
    studentPage,
    userIds,
    companyIds,
    dateRangeStart,
    dateRangeEnd,
    listType,
  ]);

  useEffect(() => {
    if (listType === 'Admin') {
      if (!loading) fetchAdminActivities();
    }
    if (listType === 'Student') {
      fetchStudentActivities();
    }
  }, [fetchAdminActivities, fetchStudentActivities, loading]);

  return (
    <div className='w-200 bg-red'>
      {listType === 'Admin' ? (
        <div className='flex flex-col gap-1'>
          {adminActivities?.map((activity, i) => (
            <Activity
              key={`${activity.adminActivityId}-${i}`}
              name={getFullName(activity.adminDetails)}
              text={renderActivityText(activity, activity.activityType)}
              time={moment(activity.updatedAt).fromNow()}
              avatar={activity?.adminDetails?.thumbnail}
            />
          ))}
          {Math.ceil(adminTotalCount / 10) - 1 !== adminPage && (
            <Button
              fluid
              onClick={() => {
                setAdminPage((current) => current + 1);
              }}
            >
              Load More Admin Activites
            </Button>
          )}
        </div>
      ) : (
        <div className='flex flex-col gap-1'>
          {studentActivities.map((activity) => (
            <Activity
              key={activity.activityId}
              name={getFullName(activity.userDetails)}
              text={renderActivityText(activity, activity.activityType)}
              time={moment(activity.updatedAt).fromNow()}
              avatar={activity?.userDetails?.thumbnail}
            />
          ))}
          {Math.ceil(studentTotalCount / 10) - 1 !== studentPage && (
            <Button
              fluid
              onClick={() => {
                setStudentPage((current) => current + 1);
              }}
            >
              Load More Student Activites
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

const Activity = ({ id, name, text, time, avatar }) => {
  return (
    <div className='flex items-center gap-3 px-6 pt-3 mb-2 border-t rounded w-100'>
      <div className='flex-0.1 w-15 '>
        <RenderProfilePic thumbnail={avatar} name={name} size={3} />
      </div>
      <div className='flex-1 '>
        <div className='flex items-center justify-between'>
          <h1 className='text-lg font-semibold'>{name}</h1>
          <p className='text-sm text-gray-500'>{time}</p>
        </div>
        <p className='text-sm text-gray-500'>{text}</p>
      </div>
    </div>
  );
};
